import React, { useState } from "react";
import Status from "../Components/Status";
import env, { normalPriceCount, rxFindCount } from "../../env";
import ProductQuickDetail from "./ProductComponent/ProductQuickDetail";
import PostReq from "../../utils/PostReq";
import ErrorAction from "../../components/Modal/ErrorAction";
function ProductTableRow(props) {
  const [Alert, setAlert] = useState(false);
  const [openOption, setOpenOption] = useState(0);
  const [Count, setCount] = useState("");
  const token = props.token;
  const activeAcc = props.index === props.detail;
  const product = props.product;
  const selectItems = props.selectItems;
  var index = props.index;
  const ChangeReserve = async (status) => {
    const result = await PostReq({
      method: "Post",
      url: "/panel/product/reserve-product",
      body: { productId: product._id, isReserve: status },
    });
    window.location.reload();
  };

  const updateCheckBox = (e) => {
    props.setSelectItems((existingItems) => {
      return [
        ...existingItems.slice(0, index),
        e.target.checked ? product.sku : false,
        ...existingItems.slice(index + 1),
      ];
    });
  };
  const HandleReserve = () => {
    if (product.isReserve) {
      ChangeReserve(false);
    } else {
      ChangeReserve(true);
    }
    setAlert(false);
  };
  return (
    <React.Fragment>
      <tr className={activeAcc ? "activeAccordion" : "accordion"}>
        <td className="checkBoxStyle">
          {product.isMaster ? (
            <></>
          ) : (
            <input
              type="checkbox"
              checked={selectItems[index]}
              onChange={(e) => updateCheckBox(e)}
            />
          )}
        </td>

        <td>
          <div className="cu-avatar">
            <img
              src={
                product.thumbUrl
                  ? env.siteApiUrl + product.thumbUrl
                  : env.defaultProduct
              }
              alt={product ? product.title : "default"}
              className={product.isMaster ? "masterImage" : "slaveImage"}
            />
            <div
              className="cu-name"
              onClick={() => {
                if (props.isShemsh) {
                  window.location.href = "/shemsh/detail/" + product._id;
                } else {
                  window.location.href = "/products/detail/" + product._id;
                }
              }}
            >
              <p className="name">{product.title}</p>
              <p className="email">{product.sku}</p>
            </div>
            {product.moreInformation ? (
              <i
                className="fa fa-comment-o"
                title={product.moreInformation}
              ></i>
            ) : (
              <></>
            )}
          </div>
        </td>

        <td>
          <div className="order-price">
            <p>
              {product.categories &&
                product.categories.map((cat, i) => (
                  <small key={i}>{cat.title} | </small>
                ))}
            </p>
          </div>
        </td>
        <td>
          <div className="order-num">
            <span>{product.isMojood ? "موجود" : "ناموجود"}</span>
          </div>
        </td>

        <td>
          <div className="order-num existSmall">
            <p>{product.weight + "g"}</p>
          </div>
        </td>
        {token.access === "manager" ? (
          <td>
            <span
              className={`status-box ${product.isReserve ? "isReserve" : ""}`}
              onClick={() => setAlert(true)}
            >
              {product.isReserve ? "رزرو شده" : "قابل سفارش"}
            </span>
          </td>
        ) : (
          <></>
        )}

        <td>
          <div className="more-btn">
            <i
              className={`tableIcon fas ${
                activeAcc ? "fa-chevron-up" : "fa-chevron-down"
              }`}
              onClick={() => props.showDetail(activeAcc ? "-1" : props.index)}
            ></i>
            <i
              className="tableIcon fas fa-edit"
              onClick={() => {
                if (props.isShemsh) {
                  window.location.href = "/shemsh/detail/" + product._id;
                } else {
                  window.location.href = "/products/detail/" + product._id;
                }
              }}
            ></i>
          </div>
        </td>
      </tr>
      {Alert ? (
        <ErrorAction
          status={"DELETE"}
          color={"orange"}
          title={"حذف آیتم"}
          text={`محصول به وضعیت ${
            product.isReserve ? "قابل سفارش" : "رزرو شده"
          } تغییر میکند.آیا مطمعن هستید؟`}
          linkText={""}
          style={{ direction: "rtl" }}
          buttonText="بله"
          close={() => setAlert()}
          action={HandleReserve}
        />
      ) : (
        <></>
      )}
      {activeAcc ? (
        <tr className="sub-order">
          <td colSpan="9">
            <ProductQuickDetail product={product} />
          </td>
        </tr>
      ) : (
        <React.Fragment></React.Fragment>
      )}
    </React.Fragment>
  );
}
export default ProductTableRow;
